export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  // 请求相关
  'component.request.failed': '请求失败！',
  'component.request.token.expired': '登录已过期，请重新登录',
  'component.request.no.response': '服务无响应，请重试',
  'component.request.error': '请求出错，请重试',
  'component.request.status': '响应状态码：{status}',
};
